/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proof_Heroic_Sawfish_DropInputs */

const fr_proof_heroic_sawfish_drop = /** @type {(inputs: Proof_Heroic_Sawfish_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner une date`)
};

/**

* @param {Proof_Heroic_Sawfish_DropInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const proof_heroic_sawfish_drop = /** @type {((inputs?: Proof_Heroic_Sawfish_DropInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proof_Heroic_Sawfish_DropInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_proof_heroic_sawfish_drop(inputs)
});